export default __webpack_public_path__ + "static/media/company.b909c1a2.svg";